import React from 'react';
import { connect } from 'react-redux';

import * as UserActions from "../../data/users/UserActions";
import TeamMemberList from "./TeamMemberList";

const mapStateToProps = (state, ownProps) => ({
});

const mapDispatchToProps = {
    // Invite Actions
    revokeInvite: UserActions.revokeInvite,

    // Team Member Action
    removeTeamMember: UserActions.removeTeamMember
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TeamMemberList);
